{/*import React, { useState } from "react";
import dummyJobs from "../data/jobsstatus";
import ProgressBar from "../components/ProgressBar";
import "../styles/ApplicationStatus.css"

export default function StatusPage() {

  const [jobs, setJobs] = useState(dummyJobs);
  const [selectedJobId, setSelectedJobId] = useState(jobs[0].id);

  const [mobileView, setMobileView] = useState("list"); 
  const isMobile = window.innerWidth <= 768;

  const selectedJob = jobs.find((j) => j.id === selectedJobId);

  const updateJob = (jobId, updateFn) => {
    setJobs((prev) => prev.map((j) => (j.id === jobId ? updateFn(j) : j)));
  };

  // ----- HEADER COUNTS -----
  const totalApplications =
    selectedJob.applications.length + 1;

  const recruiterActionsCount = selectedJob.currentApplication.history.filter(
    (h) =>
      h.status === "Application Viewed" ||
      h.status === "Shortlisted" ||
      h.status === "Rejected" ||
      h.status === "Contacted by Email"
  ).length;

  // ----- SIMULATION HELPERS -----
  const appendStatus = (status) => {
    updateJob(selectedJobId, (old) => {
      const now = new Date().toISOString();
      return {
        ...old,
        currentApplication: {
          status,
          history: [...old.currentApplication.history, { status, date: now }],
        },
      };
    });
  };

  const simulateView = () => {
    appendStatus("Application Viewed");
    updateJob(selectedJobId, (old) => {
      const apps = old.applications.map((a, i) =>
        i % 2 === 0 ? { ...a, status: "Application Viewed" } : a
      );
      return { ...old, applications: apps };
    });
  };

  // const simulateShortlist = () => {
  //   appendStatus("Shortlisted");
  //   appendStatus("Awaiting Recruiter Action");
  // };

  const simulateShortlist = () => {
    const alreadyRejected = selectedJob.currentApplication.history.some(
      (h) => h.status === "Rejected"
    );
  
    if (alreadyRejected) return;
  
    appendStatus("Shortlisted");
    appendStatus("Awaiting Recruiter Action");
  };
  

  const simulateReject = () => {
    appendStatus("Rejected");
    appendStatus("Awaiting Recruiter Action");
  };

  // const simulateContacted = () => {
  //   appendStatus("Contacted by Email");
  // };

  const simulateContacted = () => {
    const alreadyRejected = selectedJob.currentApplication.history.some(
      (h) => h.status === "Rejected"
    );
  
    if (alreadyRejected) return; 
  
    appendStatus("Contacted by Email");
  };
  

  const reset = () => {
    updateJob(selectedJobId, (old) => ({
      ...old,
      currentApplication: {
        status: "Awaiting Recruiter Action",
        history: [
          { status: "Applied", date: new Date().toISOString() },
          { status: "Application Sent", date: new Date().toISOString() },
          { status: "Awaiting Recruiter Action", date: null },
        ],
      },
      applications: old.applications.map((a) => ({ ...a, status: "Applied" })),
    }));
  };
 
  if (isMobile) {
    // ----------- MOBILE JOB LIST -----------
    if (mobileView === "list") {
      return (
        <aside className="job-list-card">
          <h2 style={{color:"#4169e1", paddingTop:"10px",left:"0px"}}>Applied Jobs</h2>
          <ul className="job-list">
            {jobs.map((j) => (
              <li
                key={j.id}
                className="job-list-item"
                onClick={() => {
                  setSelectedJobId(j.id);
                  setMobileView("status"); // ✅ Navigate to status
                }}
              >
                <div>
                  <div className="job-name">{j.title}</div>
                  <div className="job-company">{j.company}</div>
                </div>
              </li>
            ))}
          </ul>
        </aside>
      );
    }

    // ----------- MOBILE STATUS PAGE -----------
    return (
      <>

        <header className="topnav">
        
        <div className="nav-inner">
          <div style={{display:"inline-flex",marginTop:"0px"}}>
        <button className="btn-resett" onClick={() => setMobileView("list")}>
                  ← 
        </button>
          <h2 className="brande"> Application Status</h2>
          </div>

          {/* <div style={{ display: "flex", gap: "20px", fontSize: "17px" ,marginLeft:"55px", marginTop:"10px"}} >
            <div className="appliess">
            <strong style={{color:"#4169e1",fontSize:"18px", textAlign:"center"}}>{totalApplications}   </strong>
            <div>Total Applies </div>
             
            </div>
            <div className="actionss">
            <strong style={{color:"#4169e1",  fontSize:"18px", textAlign:"center"}}>{recruiterActionsCount}</strong>
              <div>Recruiter Actions</div>
              
            </div>
          </div> 


        <div className="mobile-stats">
          <div className="stat-box">
            <div className="stat-number">
              {/* {totalApplications} 
              </div>
            <div className="stat-label">Total Applies</div>
          </div>

          <div className="stat-box">
            <div className="stat-number">{recruiterActionsCount}</div>
            <div className="stat-label">Recruiter Actions</div>
          </div>
        </div>

        </div>
      </header>
     
      <div style={{ padding: "12px" }}>
       

        <div className="job-header">
        <img src={selectedJob.image} alt="" className="job-imagee" />
          <div className="job-info">
            <h2 className="title">{selectedJob.title}</h2>
            <div className="company">{selectedJob.company}</div>
            <div className="location">📍 {selectedJob.location}</div>
          </div>
        </div>

        <div className="status-section">
          <h3 style={{paddingBottom:"18px"}}>Your Application Status</h3>
          <ProgressBar history={selectedJob.currentApplication.history} />
        </div>

        

        <div className="activity-box">
            <h4>Total activity on this job</h4>
            <div className="activity-row">
              
              <div>
                <div className="activity-value">{totalApplications}</div>
                <div className="activity-label">Total applications</div>
                
              </div>

              <div>
                
                <div className="activity-value">
                  {
                    selectedJob.applications.filter((a) => a.status === "Application Viewed")
                      .length +
                    (selectedJob.currentApplication.history.some((h) => h.status === "Application Viewed") ? 1 : 0)
                  }
                </div>
                <div className="activity-label">Applications viewed by recruiter</div>
              </div>
            </div>
          </div>

        <div className="sim-controls">
          <h4>Simulate recruiter actions</h4>
          <div className="controls">
            <button onClick={simulateView}>Recruiter View</button>
            <button onClick={simulateShortlist}>Shortlist</button>
            <button onClick={simulateReject}>Reject</button>
            <button onClick={simulateContacted}>Contacted</button>
            <button className="btn-reset" onClick={reset}>
              Reset
            </button>
          </div>
        </div>
      </div>
      </>
    );
  }
  return (
    <>
      {/* ---------- HEADER WITH COUNTS ---------- 
      <header className="topnav">
        <div className="nav-inner" style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
          <h1 className="brandd"> Application Status</h1>

          <div style={{ display: "flex", gap: "20px", fontSize: "17px" }}>
            <div className="applies">
            <strong style={{color:"#4169e1", paddingRight:"7px", fontSize:"18px", }}>
              {/* {totalApplications}    
              </strong>
            <div>Total Applies  |</div>
             
            </div>
            <div className="actions">
            <strong style={{color:"#4169e1", paddingRight:"7px", fontSize:"18px", }}>{recruiterActionsCount}</strong>
              <div>Recruiter Actions</div>
              
            </div>
          </div>
        </div>
      </header>

      {/* ---------- PAGE LAYOUT ---------- 
      <div className="app-layout">
        {/* ------------ LEFT COLUMN (JOB LIST) ------------ 
        <aside className="job-list-card">
          <h2 style={{color:"#222",  fontSize:"22px",marginTop:"15px",paddingBottom:"10px"}}>Applied Jobs</h2>
          <ul className="job-list">
            {jobs.map((j) => (
              <li
                key={j.id}
                className={`job-list-item ${selectedJobId === j.id ? "selected" : ""}`}
                onClick={() => setSelectedJobId(j.id)}
              >
                <div>
                  <div className="job-name">{j.title}</div>
                  <div className="job-company">{j.company}</div>
                </div>
                {/* <div className="job-cta">View</div> 
              </li>
            ))}
          </ul>
        </aside>

        {/* ------------ RIGHT COLUMN (STATUS DETAILS) ------------ 
        <section className="status-card">
          <div className="job-header">
            <img src={selectedJob.image} alt="" className="job-image" />
            <div className="job-info">
              <h3 className="title">{selectedJob.title}</h3>
              <div className="company">{selectedJob.company}</div>
              <div className="location">📍 {selectedJob.location}</div>
            </div>
          </div>

          <div className="status-section">
            <h3 style={{paddingBottom:"23px"}}>Your Application Status</h3>
            <ProgressBar history={selectedJob.currentApplication.history} />
          </div>

          <div className="activity-box">
            <h4 >Total activity on this job</h4>
            <div className="activity-row">
              <div>
                <div className="activity-value">{totalApplications}</div>
                <div className="activity-label">Total applications</div>
                
              </div>

              <div>
                
                <div className="activity-value">
                  {
                    selectedJob.applications.filter((a) => a.status === "Application Viewed")
                      .length +
                    (selectedJob.currentApplication.history.some((h) => h.status === "Application Viewed") ? 1 : 0)
                  }
                </div>
                <div className="activity-label">Applications viewed by recruiter</div>
              </div>
            </div>
          </div>

          <div className="sim-controls">
            <h4>Simulate recruiter actions </h4>
            <div className="controls">
              <button onClick={simulateView}>Recruiter View</button>
              <button onClick={simulateShortlist}>Shortlist</button>
              <button onClick={simulateReject}>Reject</button>
              <button onClick={simulateContacted}>Contacted by Email</button>
              <button className="btn-reset" onClick={reset}>Reset</button>
            </div>
            {/* <p className="hint">Changes appear immediately & update the progress bar.</p> 
          </div>
        </section>
      </div>
    </>
  );
}
*/}


// added on 1-12-2025

import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import ProgressBar from "../components/ProgressBar";
import "../styles/ApplicationStatus.css";


export default function StatusPage() {
  const navigate = useNavigate();
  const [jobs, setJobs] = useState([]); // loaded from backend
  const [selectedJobId, setSelectedJobId] = useState(null);
  const [mobileView, setMobileView] = useState("list");
  const isMobile = window.innerWidth <= 768;
  const token = typeof window !== "undefined" ? localStorage.getItem("token") : null;

  // Helper: map backend single status -> timeline history (Option C)
  const buildHistoryFromStatus = (status, appliedAt) => {
    // Normalize status for matching
    const s = (status || "").toLowerCase();
    const nowISO = new Date().toISOString();
    const appliedDate = appliedAt || nowISO;
    // base item
    const applied = { status: "Applied", date: appliedDate };
    const sent = {status : "Application Sent", date:appliedDate}
    const viewed = { status: "Application Viewed", date: nowISO };
    const awaiting = { status: "Awaiting Recruiter Action", date: null };

    const mapping = {
      "under review": [applied,sent, { status: "Under review", date: nowISO }],
      "application viewed": [applied,sent, viewed],
      "shortlisted": [applied, sent,viewed, { status: "Shortlisted", date: nowISO }],
      "interview scheduled": [applied, sent,viewed, { status: "Shortlisted", date: nowISO }, { status: "Interview Scheduled", date: nowISO }],
      "offered": [applied, sent,viewed, { status: "Shortlisted", date: nowISO }, { status: "Offered", date: nowISO }], // remove
      "rejected": [applied, sent,viewed, { status: "Rejected", date: nowISO }],
      "hired": [applied, sent,viewed, { status: "Shortlisted", date: nowISO }, { status: "Hired", date: nowISO }], // remove status shortlist 
      "contacted by email": [applied, sent,viewed, { status: "Contacted by Email", date: nowISO }],
      "interviewed": [applied, sent,viewed, { status: "Interviewed", date: nowISO }],
      "offer accepted": [applied, sent,viewed, { status: "Offer Accepted", date: nowISO }], // Remove 
      "offer declined": [applied, sent,viewed, { status: "Offer Declined", date: nowISO }], // remove
      "in process": [applied, sent,viewed, { status: "In Process", date: nowISO }], // shortlisted
      "assesment selected": [applied, sent,viewed, { status: "Assesment Selected", date: nowISO }], // shortlisted
      "shortlisted": [applied, sent,viewed, { status: "Shortlisted", date: nowISO }],
      "awaiting recruiter action": [applied, awaiting],
    };

    // find mapped or fallback to [Applied, status]
    const found = mapping[s];
    if (found) return found;
    if (!status) return [applied, awaiting];
    return [applied, { status: status, date: nowISO }];
  };

  // Convert backend applications array -> UI job objects
  const convertAppsToJobs = (apps) => {
    // apps expected to be array of application objects as returned by /api/applications (me)
    // Each app: { id, job: { title, company_name, location }, status, applied_at, ... }
    return apps.map((a) => {
      const jobTitle = a.job?.title || a.job?.jobTitle || "Untitled";
      const company = a.job?.company_name || a.job?.company || "";
      const location = a.job?.location || "";
      return {
        id: a.job?.job_id ?? a.job_id ?? a.job?.id ?? a.id, // used as UI job id (job id preferred)
        applicationId: a.id, // keep real application id for backend updates
        title: jobTitle,
        company: company,
        location: location,
        image: a.job?.image || "/default-job.png",
        // keep original applied list for counts if present
        applications: a.job?.applications || [],
        // currentApplication used by ProgressBar: we store history & status
        currentApplication: {
          status: a.status || "Awaiting Recruiter Action",
          history: buildHistoryFromStatus(a.status, a.applied_at || a.appliedAt || a.applied_on),
          // include the raw application id for update calls
          application_id: a.id,
        },
      };
    });
  };

  // Load candidate applications from backend on mount
  useEffect(() => {
    const token = localStorage.getItem("access_token");
    async function loadMyApplications() {
      try {
        const res = await fetch("http://144.91.102.67:8002/api/applications/me", {
          headers: {
            Authorization: token ? `Bearer ${token}` : "",
          },
        });

        if (!res.ok) {
          console.error("Failed to fetch applications:", res.status, await res.text());
          return;
        }

        const apps = await res.json();
        const jobsFromApps = convertAppsToJobs(apps);

        setJobs(jobsFromApps);
        if (jobsFromApps.length) setSelectedJobId(jobsFromApps[0].id);
      } catch (err) {
        console.error("Error loading applications:", err);
      }
    }

    loadMyApplications();
}, []);  // ⬅ KEEP THIS – it is valid and does NOT require exhaustive-deps rule


  const selectedJob = jobs.find((j) => j.id === selectedJobId) || (jobs.length ? jobs[0] : null);

   const updateLocalJobStatus = (applicationId, newStatus) => {
     setJobs((prev) =>
       prev.map((j) => {
         if (j.applicationId === applicationId) {
          return {
             ...j,
             currentApplication: {
               ...j.currentApplication,
               status: newStatus,
               history: buildHistoryFromStatus(newStatus, j.currentApplication.history?.[0]?.date),
             },
           };
         }
         return j;
      })
     );
   };

  // Helper: call backend to update status for an application
   const updateStatusBackend = async (applicationId, newStatus) => {
    try {
      const token = localStorage.getItem("access_token");
       const res = await fetch(
         `http://144.91.102.67:8002/api/applications/${applicationId}/status?status=${encodeURIComponent(newStatus)}`,
         {
           method: "PUT",
           headers: {
             Authorization: token ? `Bearer ${token}` : "",
             "Content-Type": "application/json",
           },
         }
       );

       if (!res.ok) {
         const text = await res.text();
         console.error("Failed to update status:", res.status, text);
         return false;
       }

      // update local UI state
       updateLocalJobStatus(applicationId, newStatus);
       return true;
     } catch (err) {
       console.error("Error calling update status API:", err);
       return false;
     }
   };

  // ------- Simulator actions (now connected to backend) -------
  // const simulateView = async () => {
  //   if (!selectedJob) return;
  //   const appId = selectedJob.currentApplication.application_id || selectedJob.applicationId;
  //   if (!appId) return;

  //   await updateStatusBackend(appId, "Application Viewed");
  // };

  // const simulateShortlist = async () => {
  //   if (!selectedJob) return;
  //   const appId = selectedJob.currentApplication.application_id || selectedJob.applicationId;
  //   if (!appId) return;

    // check current history for 'Rejected' - don't allow if already rejected
    // const alreadyRejected = selectedJob.currentApplication.history?.some((h) => h.status?.toLowerCase() === "rejected");
    // if (alreadyRejected) return;

    // await updateStatusBackend(appId, "Shortlisted");
    // optionally also set "Awaiting Recruiter Action" after shortlist (if desired)
    // await updateStatusBackend(appId, "Awaiting Recruiter Action");
  // };

  // const simulateReject = async () => {
  //   if (!selectedJob) return;
  //   const appId = selectedJob.currentApplication.application_id || selectedJob.applicationId;
  //   if (!appId) return;

  //   await updateStatusBackend(appId, "Rejected");
  // };

  // const simulateContacted = async () => {
  //   if (!selectedJob) return;
  //   const appId = selectedJob.currentApplication.application_id || selectedJob.applicationId;
  //   if (!appId) return;

  //   const alreadyRejected = selectedJob.currentApplication.history?.some((h) => h.status?.toLowerCase() === "rejected");
  //   if (alreadyRejected) return;

  //   await updateStatusBackend(appId, "Contacted by Email");
  // };

  // Reset: set back to "Awaiting Recruiter Action" locally and in backend
  // const reset = async () => {
  //   if (!selectedJob) return;
  //   const appId = selectedJob.currentApplication.application_id || selectedJob.applicationId;
  //   if (!appId) return;

  //   await updateStatusBackend(appId, "Awaiting Recruiter Action");
  // };

  // Header counts (keeps same calculation logic - but more robust)
  //const totalApplications = (selectedJob?.applications?.length || 0) + 1;
  // added on 2-1-2026
  const totalApplications = jobs.length;
  {/*const recruiterActionsCount = (selectedJob?.currentApplication?.history || []).filter(
    (h) =>
      h.status === "Application Viewed" ||
      h.status === "Shortlisted" ||
      h.status === "Rejected" ||
      h.status === "Contacted by Email"
  ).length;*/}
  // added on 2-1-2026
  const recruiterActionsCount = jobs.reduce((total, job) => {
  const actions = (job.currentApplication?.history || []).filter(
    (h) =>
      //h.status === "Application Viewed" ||
      h.status === "Shortlisted" ||
      h.status === "Rejected" ||
      h.status === "Contacted by Email"
  ).length;

  return total + actions;
}, 0);

  if (isMobile) {
    if (mobileView === "list") {
      return (
        <aside className="job-list-card">
          <h2 style={{ color: "#4169e1", paddingTop: "10px", left: "0px" }}>Applied Jobs</h2>
          <ul className="job-list">
            {jobs.map((j) => (
              <li
                key={j.id}
                className="job-list-item"
                onClick={() => {
                  setSelectedJobId(j.id);
                  setMobileView("status");
                }}
              >
                <div>
                  <div className="job-name">{j.title}</div>
                  <div className="job-company">{j.company}</div>
                </div>
              </li>
            ))}
          </ul>
        </aside>
      );
    }

    return (
      <>
        <header className="topnav">
          <div className="nav-inner">
            <div style={{ display: "inline-flex", marginTop: "0px" }}>
              <button className="btn-resett" onClick={() => setMobileView("list")}>
                ←
              </button>
              <h2 className="brande"> Application Status</h2>
            </div>

            <div className="mobile-stats">
              <div className="stat-box">
                <div className="stat-number">{totalApplications}</div>
                <div className="stat-label">Total Applies</div>
              </div>

              <div className="stat-box">
                <div className="stat-number">{recruiterActionsCount}</div>
                <div className="stat-label">Recruiter Actions</div>
              </div>
            </div>
          </div>
        </header>

        <div style={{ padding: "12px" }}>
          <div className="job-status-header">
            <img src={selectedJob?.image} alt="" className="job-imagee" />
            <div className="job-info">
              <h2 className="title">{selectedJob?.title}</h2>
              <div className="company">{selectedJob?.company}</div>
              <div className="location">📍 {selectedJob?.location}</div>
            </div>
          </div>

          <div className="status-section">
            <h3 style={{ paddingBottom: "18px" }}>Your Application Status</h3>
            <ProgressBar history={selectedJob?.currentApplication?.history || []} />
          </div>

          <div className="activity-box">
            <h4>Total activity on this job</h4>
            <div className="activity-row">
              <div>
                <div className="activity-value">{totalApplications}</div>
                <div className="activity-label">Total applications</div>
              </div>

              <div>
                <div className="activity-value">
                  {
                    (selectedJob?.applications || []).filter((a) => a.status === "Application Viewed").length +
                    (selectedJob?.currentApplication?.history?.some((h) => h.status === "Application Viewed") ? 1 : 0)
                  }
                </div>
                <div className="activity-label">Applications viewed by recruiter</div>
              </div>
            </div>
          </div>

          {/* <div className="sim-controls">
            <h4>Simulate recruiter actions</h4>
            <div className="controls">
              <button onClick={simulateView}>Recruiter View</button>
              <button onClick={simulateShortlist}>Shortlist</button>
              <button onClick={simulateReject}>Reject</button>
              <button onClick={simulateContacted}>Contacted</button>
              <button className="btn-reset" onClick={reset}>
                Reset
              </button>
            </div>
          </div> */}
        </div>
      </>
    );
  }

  return (
    <>
      <header className="topnav">
        
        <div className="nav-inner" style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
             
          <h1 className="abrandd">
          <button className="btn-resett" onClick={()=>navigate("/candidate-dashboard")}>
                ←
              </button>
            
             Application Status</h1>

          <div style={{ display: "flex", gap: "20px", fontSize: "17px" }}>
            <div className="applies">
              <strong style={{ color: "#4169e1", paddingRight: "7px", fontSize: "18px" }}>{totalApplications}</strong>
              <div>Total Applies  |</div>
            </div>
            <div className="actions">
              <strong style={{ color: "#4169e1", paddingRight: "7px", fontSize: "18px" }}>{recruiterActionsCount}</strong>
              <div>Recruiter Actions</div>
            </div>
          </div>
        </div>
      </header>

      <div className="app-layout">
        <aside className="job-list-card">
          <h2 style={{ color: "#222", fontSize: "22px", marginTop: "15px", paddingBottom: "10px" }}>Applied Jobs</h2>
          <ul className="job-list">
            {jobs.map((j) => (
              <li
                key={j.id}
                className={`job-list-item ${selectedJobId === j.id ? "selected" : ""}`}
                onClick={() => setSelectedJobId(j.id)}
              >
                <div>
                  <div className="job-name">{j.title}</div>
                  <div className="job-company">{j.company}</div>
                </div>
              </li>
            ))}
          </ul>
        </aside>

        <section className="status-card">
          <div className="job-status-header">
            <img src={selectedJob?.image} alt="" className="job-image" />
            <div className="job-info">
              <h3 className="title">{selectedJob?.title}</h3>
              <div className="company">{selectedJob?.company}</div>
              <div className="location">📍 {selectedJob?.location}</div>
            </div>
          </div>

          <div className="status-section">
            <h3 style={{ paddingBottom: "23px" }}>Your Application Status</h3>
            <ProgressBar history={selectedJob?.currentApplication?.history || []} />
          </div>

          <div className="activity-box">
            <h4>Total activity on this job</h4>
            <div className="activity-row">
              <div>
                <div className="activity-value">{totalApplications}</div>
                <div className="activity-label">Total applications</div>
              </div>

              <div>
                <div className="activity-value">
                  {
                    (selectedJob?.applications || []).filter((a) => a.status === "Application Viewed").length +
                    (selectedJob?.currentApplication?.history?.some((h) => h.status === "Application Viewed") ? 1 : 0)
                  }
                </div>
                <div className="activity-label">Applications viewed by recruiter</div>
              </div>
            </div>
          </div>

          {/* <div className="sim-controls">
            <h4>Simulate recruiter actions </h4>
            <div className="controls">
              <button onClick={simulateView}>Recruiter View</button>
              <button onClick={simulateShortlist}>Shortlist</button>
              <button onClick={simulateReject}>Reject</button>
              <button onClick={simulateContacted}>Contacted by Email</button>
              <button className="btn-reset" onClick={reset}>Reset</button>
            </div>
          </div> */}
        </section>
      </div>
    </>
  );
}
